import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAiModelOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAiModelOptionsQuery = { __typename?: 'query_root', get_ai_model_options: { __typename?: 'AiModelOptionsResult', efforts: Array<string>, providers: Array<{ __typename?: 'AiProviderOption', provider: string, label: string, models: Array<{ __typename?: 'AiModelOption', id: string, label: string }> }>, features: Array<{ __typename?: 'AiFeatureModelConfig', feature: string, label: string, provider: string, model_name: string, effort?: string | null }> } };


export const GetAiModelOptionsDocument = gql`
    query getAiModelOptions {
  get_ai_model_options {
    efforts
    providers {
      provider
      label
      models {
        id
        label
      }
    }
    features {
      feature
      label
      provider
      model_name
      effort
    }
  }
}
    `;

/**
 * __useGetAiModelOptionsQuery__
 *
 * To run a query within a React component, call `useGetAiModelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiModelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiModelOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiModelOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>(GetAiModelOptionsDocument, options);
      }
export function useGetAiModelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>(GetAiModelOptionsDocument, options);
        }
export function useGetAiModelOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>(GetAiModelOptionsDocument, options);
        }
export type GetAiModelOptionsQueryHookResult = ReturnType<typeof useGetAiModelOptionsQuery>;
export type GetAiModelOptionsLazyQueryHookResult = ReturnType<typeof useGetAiModelOptionsLazyQuery>;
export type GetAiModelOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAiModelOptionsSuspenseQuery>;
export type GetAiModelOptionsQueryResult = Apollo.QueryResult<GetAiModelOptionsQuery, GetAiModelOptionsQueryVariables>;